<template>
  <p v-if="!tickets.length" class="no-ticket f-bold">
    {{ $t("orders.no-tickets") }}
  </p>

  <ul v-else class="list">
    <li v-for="ticket in visible" :key="ticket.id" class="f-bold">
      {{ ticket.name }}
    </li>

    <li v-if="hasMore" class="link" @click="onShowMore">
      {{ $t("button.show-more") }}
    </li>
  </ul>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { useParsedRow } from "../../composables/useParsedRow";
import { useOrdersDialogsInject } from "../../composables/useOrdersDialogs";

const props = defineProps<{ row: Record<string, unknown> }>();

const dialogs = useOrdersDialogsInject();
const parsed = useParsedRow(props.row);

const tickets = computed(() => parsed.tickets);
const visible = computed(() => tickets.value.slice(0, 4));
const hasMore = computed(() => tickets.value.length > 4);

/**
 * Open the shared tickets dialog with this row's full ticket list.
 *
 * @returns {boolean} Sentinel.
 */
function onShowMore(): boolean {
  dialogs.openTickets(tickets.value);

  return true;
}
</script>

<style scoped lang="scss">
@use "@/styles/variables.scss" as *;

.list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.no-ticket {
  text-align: center;
}

.link {
  text-decoration: underline;
  cursor: pointer;
  color: $color-dark-cyan;
}
</style>
